import { useCallback, useState } from 'react';
import { SkippableFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { useOnCurrentTimeChanged } from '@/scenarios/legacy-player/hooks/useOnCurrentTimeChanged';

import { isCurrentFragment } from '../../utils/is-current-fragment';

const SKIP_CHECK_DELAY = 1000;

export function useCurrentSkippableFragment(
    fragments: SkippableFragment[]
): SkippableFragment | undefined {
    const [currentFragment, setCurrentFragment] = useState<SkippableFragment>();

    const onCurrentTimeChanged = useCallback(
        (currentTime: number) => {
            setCurrentFragment(
                fragments?.find((fragment) => isCurrentFragment(fragment, currentTime))
            );
        },
        [fragments]
    );

    useOnCurrentTimeChanged(onCurrentTimeChanged, SKIP_CHECK_DELAY);

    return currentFragment;
}
